export const DAY_WIDTH = 70;
export const FIRST_COLUMN_GAP = 1.5;
